export const APP_DETAILS = {
  FA_NAME: 'نارنگی',
  EN_NAME: 'Narengi',
  AR_NAME: 'نارنگی',
  TJ_NAME: 'Narengi',
  FA_DESCRIPTION: 'نارنگی تی وی',
  EN_DESCRIPTION: 'Narengi TV',
  AR_DESCRIPTION: 'نارنگی تی وی',
  TJ_DESCRIPTION: 'Narengi телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.narengi.com',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'narengi.com',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '1.4.0',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'G-FYHNE3VNTP',
  LOGIN_URL: 'https://narengi.com/activate',
  APPS_URL: 'https://narengi.com/app',
};
